import { Component, Inject, OnInit } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import Swal from 'sweetalert2';
import { ConfigService } from '../../../helpers/config.service';
import { EmployeeService } from '../../../features/companies-users/services/employee.service';

@Component({
  selector: 'app-import-employee-step-two',
  templateUrl: './import-employee-step-two.component.html',
  styles: ``
})
export class ImportEmployeeStepTwoComponent implements OnInit {
  loading: boolean = false;
  item: any = {
    id: "1",
    profileImg: "https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg",
    nameAR: "الشركة العربية لتجارة المواد البترولية (أبسـكو)",
    nameEn: "Arabian Petroleum Supply company (APSCO)",
    city: "جدة",
    points: 556,
    package: {
      nameAR: "ولاء إيليت",
      nameEN: "Wala Elite"
    },
    employees_number: 5564,
    createdDate: '2024-01-10T13:28:27Z',

    full_name: "عبدالله أحمد",
    image: "https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg"
  }
  constructor(private _config: ConfigService,
    private _employeeService: EmployeeService,
    public dialogRef: MatDialogRef<ImportEmployeeStepTwoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,) {

  }
  ngOnInit(): void {

  }

  onConfirm() {
    this.loading = true;
    let model = { sheet_id: this.data?.sheet_id }
    this._employeeService.ConfirmImport(model).subscribe({
      next: (res: any) => {
        this.loading = false;
        this.dialogRef.close(true);
        this._config.SusseccMessage(this._config._translate.instant("employees.imported_successfully", { num: this.data?.total_success }))
      },
      error: (error: any) => {
        this.loading = false;
        // Swal.fire({
        //   title: this._config._translate.instant('swalMsg.Failed'),
        //   text: error.errors[0].massage,
        //   icon: 'error',
        //   confirmButtonText: this._config._translate.instant('swalMsg.Ok'),
        // })
      }
    })
  }
}
